var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_631_1649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5625H22.6875C23.6383 8.43365 24.0817 10.5215 23.9735 12.6175C23.8652 14.7136 23.2091 16.7446 22.0706 18.5079C20.9321 20.2711 19.3511 21.7049 17.4852 22.6662C15.6194 23.6274 13.5341 24.0825 11.4375 23.9859",
    fill: "#FFCC44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7344 14.7188L11.4375 23.9859C9.33318 23.8901 7.29114 23.2421 5.51666 22.1069C3.74218 20.9718 2.29777 19.3895 1.32864 17.5192C0.359502 15.6488 -0.100216 13.5563 -0.00430812 11.452C0.0915998 9.34768 0.739754 7.30568 1.87501 5.53125",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.56259H22.6875C21.7301 4.67609 20.291 3.0762 18.5161 1.92509C16.7411 0.773985 14.6934 0.112566 12.5805 0.0078703C10.4675 -0.096825 8.36448 0.358925 6.48443 1.32893C4.60438 2.29894 3.01418 3.74872 1.875 5.53134L7.26562 14.7188",
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.9219C14.7183 16.9219 16.9219 14.7183 16.9219 12C16.9219 9.28172 14.7183 7.07812 12 7.07812C9.28172 7.07812 7.07812 9.28172 7.07812 12C7.07812 14.7183 9.28172 16.9219 12 16.9219Z",
    fill: "#4285F4",
    stroke: "#F1F1F1",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_631_1649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChrome);
export default __webpack_public_path__ + "static/media/icon-chrome.f1d7fa6482077ae5f60dde64b17a2e8f.svg";
export { ForwardRef as ReactComponent };